import React from 'react';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component

import styles from './Error.scss';// to import local scss fle

const Error = props => (
  <label htmlFor="error" className={styles.errorMessage}>{props.message}</label>
);

Error.propTypes = {
  message: PropTypes.string,
};

Error.defaultProps = {
  message: '',
};

export default Error;



// WEBPACK FOOTER //
// ./src/components/ErrorMessage/Error.js